import { Model } from '@lernetz/ts-lib';
import { View, ViewConfig } from '@lernetz/ts-lib/src/view/View';
import { route } from '@lernetz/ts-lib/src/Setup';
import template from './Iframely.html';

export interface IframelyConfig {
    route?:string;
    url:string;
}

export class Iframely extends Model {

    public readonly route:string;
    public readonly url:string;

    public fallbackUrl:string;

    public constructor( config?:IframelyConfig ) {
        super( { fallbackUrl:null, route:'iframely', ...config } );
    }
}

export class IframelyView extends View<Iframely> {

    private html:string;

    public constructor( config?:ViewConfig<Iframely> ) {
        super( { template, ...config } );
    }

    async init() {
        if( !this.html ) {
            const iframelyResult = await route( this.data.route, this.data ).load();
            this.html = iframelyResult[ 'html' ];
        }

        if (this.html) {
            this.node.innerHTML = this.html;
        }
        else {
            this.data.fallbackUrl = this.data.url;
        }
    }
}
